export const youtubeID = (url: string) => {
    const id = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return undefined !== id[2] ? id[2].split(/[^0-9a-z_\-]/i)[0] : id[0];
};

export interface WidgetInputItem {
    title: string;
    value: string;
    placeholder?: string;
    charLimit?: number;
}

export const promotionInputs: WidgetInputItem[] = [
    {
        title: 'Title',
        value: 'title'
    },
    {
        title: 'Description',
        value: 'description'
    },
    {
        title: 'Call to Action (eg Signup, Download, Review...)',
        placeholder: 'e.g. Sign up',
        value: 'callToAction',
        charLimit: 20
    },
    {
        title: 'URL',
        placeholder: 'e.g. https://google.com',
        value: 'link'
    }
];

export const ratingInputs: WidgetInputItem[] = [
    {
        title: 'Title',
        placeholder: 'e.g. How are we doing?',
        value: 'title'
    },
    {
        title: 'Description',
        placeholder: 'e.g. Let us know by leaving a comment below',
        value: 'description'
    }
];
